module.exports = __webpack_public_path__ + "img/filigrana-artefatto.68640cc0.png";